export default {
  text: '{{threshold}} miesięczna sprzedaż: {{amount}}',
  label: '{{threshold}} miesięczna sprzedaż:',
  no_discount: 'brak rabatu',
  discount_badge: '-{{percentage}}%',
};
